export const LIST_DISCIPLINES = /* GraphQL */ `
  query ListDisciplines {
    listDisciplines {
      group
      label
      value
    }
  }
`;

export const LIST_DISCIPLINES_QUERY_OPTIONS = { errorPolicy: 'all' }
